import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { auth } from './firebase';

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);
  
  const handleBack = () => {
    navigate(user ? '/' : '/login');
  };
  
  return (
    <div style={styles.container}>
      <button onClick={handleBack} style={styles.backButton}>
        <IoArrowBack size={24} />
      </button>
      <p style={styles.updateDate}>{t('legal.lastUpdated')} 20 {t('legal.september')} 2025</p>

      <h1 style={styles.title}>{t('legal.privacyPolicy')}</h1>

      <p style={styles.text}>
        {t('legal.privacyDescription')}
      </p>

      <h2 style={styles.subtitle}>1. {t('legal.dataCollection')}</h2>
      <p style={styles.text}>{t('legal.dataCollectionDescription')}</p>
      <ul style={styles.list}>
        <li>{t('legal.dataItem1')}</li>
        <li>{t('legal.dataItem2')}</li>
        <li>{t('legal.dataItem3')}</li>
        <li>{t('legal.dataItem4')}</li>
        <li>{t('legal.dataItem5')}</li>
      </ul>

      <h2 style={styles.subtitle}>2. {t('legal.dataUsage')}</h2>
      <p style={styles.text}>
        {t('legal.dataUsageDescription')}
      </p>

      <h2 style={styles.subtitle}>3. {t('legal.dataRetention')}</h2>
      <p style={styles.text}>
        {t('legal.dataRetentionDescription')}
      </p>

      <h2 style={styles.subtitle}>4. {t('legal.userRights')}</h2>
      <p style={styles.text}>
        {t('legal.userRightsDescription')} <b>support@wishareapp.com</b>
      </p>

      <h2 style={styles.subtitle}>5. {t('legal.dataSecurity')}</h2>
      <p style={styles.text}>
        {t('legal.dataSecurityDescription')}
      </p>

      <h2 style={styles.subtitle}>6. {t('legal.thirdPartyServices')}</h2>
      <p style={styles.text}>
        {t('legal.thirdPartyServicesDescription')}
      </p>

      <h2 style={styles.subtitle}>7. {t('legal.cookiesAnalytics')}</h2>
      <p style={styles.text}>
        {t('legal.cookiesAnalyticsDescription')}
      </p>

      <h2 style={styles.subtitle}>8. {t('legal.affiliateLinks')}</h2>
      <p style={styles.text}>
        {t('legal.affiliateLinksDescription')}
      </p>

      <h2 style={styles.subtitle}>9. {t('legal.contact')}</h2>
      <p style={styles.text}>
        {t('legal.contactEmail')} <b>support@wishareapp.com</b>
      </p>

      <p style={styles.text}>
        {t('legal.acceptTerms')}
      </p>

      <hr style={styles.divider} />
      <p style={styles.footer}>© 2025 Wishare. {t('legal.allRightsReserved')}</p>
    </div>
  );
}

const styles = {
  container: {
    padding: "24px",
    paddingTop: "calc(env(safe-area-inset-top, 0px) + 72px)",
    backgroundColor: "#fff",
    fontFamily: "Poppins, sans-serif",
    color: "#111",
    minHeight: "100vh",
    paddingBottom: "80px",
    position: "relative",
  },
  backButton: {
    position: "absolute",
    top: "calc(env(safe-area-inset-top, 0px) + 50px)",
    left: "16px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#111",
    zIndex: 20,
  },
  updateDate: {
    fontSize: "12px",
    color: "#666",
    marginBottom: "16px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "600",
    marginBottom: "24px",
  },
  subtitle: {
    fontSize: "16px",
    fontWeight: "600",
    marginTop: "20px",
    marginBottom: "10px",
  },
  text: {
    fontSize: "14px",
    lineHeight: "1.7",
    marginBottom: "12px",
  },
  list: {
    paddingLeft: "20px",
    fontSize: "14px",
    color: "#111",
    marginBottom: "12px",
  },
  divider: {
    marginTop: "40px",
    borderTop: "1px solid #ddd",
  },
  footer: {
    fontSize: "12px",
    color: "#666",
    marginTop: "12px",
  },
};